import React from "react";
import { useSelector } from "react-redux";
import moment from "moment-timezone";

import { Table } from "../../../../../components/ui";
import { IColum } from "../../../../../utils/copyToClipboardInXlsFormat";
import { HOURS_12_FORMAT_WITH_DATE } from "../../../../../constants";
import { ICustomerBillingHistory } from "../../../../../api/billing/index.types";

const countDaysExcludingWeekends = (startDate: string, endDate: string) => {
  const start = moment(startDate);
  const end = moment(endDate);
  let count = 0;

  while (start.isSameOrBefore(end, "day")) {
    if (start.day() !== 6 && start.day() !== 0) {
      // 0 is Sunday
      // 1 is Monday
      // 2 is Tuesday
      // 3 is Wednesday
      // 4 is Thursday
      // 5 is Friday
      // 6 is Saturday
      count++;
    }
    start.add(1, "day");
  }

  return count;
};

const AmountTradingDays: React.FC = () => {
  const {
    data: { latestResetAndNewPurchase },
    loading,
  } = useSelector((state) => state.financials.passersStats);

  const AMOUNT_TRADING_DAYS_COLUMNS: Array<IColum> = [
    {
      by: "account_id",
      title: "Account ID",
      path: "accounts_id",
    },
    {
      by: "email",
      title: "email",
      path: "account.email",
    },
    {
      by: "name",
      title: "name",
      path: "account.name",
    },
    {
      by: "purchase_date",
      title: "purchase_date",
      path: "purchase_date",
      //@ts-ignore
      getCellValue: (purchase_date: string): React.ReactElement => {
        return (
          <span>
            {moment(purchase_date as string)
              .tz("America/Chicago")
              .format(HOURS_12_FORMAT_WITH_DATE)}
          </span>
        );
      },
      copyToClipBoardCallBack: (purchase_date: string): string => {
        return moment(purchase_date as string)
          .tz("America/Chicago")
          .format(HOURS_12_FORMAT_WITH_DATE);
      },
    },
    {
      by: "traded_days",
      title: "Traded days",
      path: "purchase_date",
      //@ts-ignore
      getCellValue: (
        purchase_date: string,
        restValues: ICustomerBillingHistory
      ): React.ReactElement => {
        const { report_title_date } = restValues;
        const tradingDays = countDaysExcludingWeekends(purchase_date, report_title_date);
        return <span>{tradingDays}</span>;
      },
      //@ts-ignore
      copyToClipBoardCallBack: (
        purchase_date: string,
        restValues: ICustomerBillingHistory
      ): number => {
        const { report_title_date } = restValues;
        return countDaysExcludingWeekends(purchase_date, report_title_date);
      },
    },
  ];

  return (
    <Table
      csv_table_name="Amount of trading days"
      theadTitle="Amount of trading days"
      columns={AMOUNT_TRADING_DAYS_COLUMNS}
      data={latestResetAndNewPurchase}
      loading={loading}
      extractKey={(row) => row.id}
      isDownloadable
      noResultsMessage=""
    />
  );
};

export default AmountTradingDays;
